export var GLOBAL_STYLESHEET_KEY = '__global__';
export var SHADOW_DOM_STYLESHEET_SETTING = '__shadow_dom_stylesheet__';
export var DEFAULT_SHADOW_CONFIG = {
  stylesheetKey: GLOBAL_STYLESHEET_KEY,
  inShadow: false,
  window: undefined,
  __isShadowConfig__: true
};
export var makeShadowConfig = function makeShadowConfig(stylesheetKey, inShadow, window) {
  return {
    stylesheetKey: stylesheetKey,
    inShadow: inShadow,
    window: window,
    __isShadowConfig__: true
  };
};
export var isShadowConfig = function isShadowConfig(value) {
  if (!(value && isRecord(value))) {
    return false;
  }
  return value.__isShadowConfig__ === true;
};
function isRecord(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}